import API from "../axiosConfig";

export const getTariffRules = async () => {
  try {
    const response = await API.get("/tariff-rules");
    return response.data;
  } catch (error) {
    console.error("Error fetching tariff-rules:", error);
    throw error;
  }
};

export const createTariffRule = async (lineData) => {
  try {
    const response = await API.post("/tariff-rules", lineData);
    return response.data;
  } catch (error) {
    console.error("Error creating tariff-rules:", error);
    throw error;
  }
};

export const updateTariffRule = async (lineId, lineData) => {
  try {
    const response = await API.put(`/tariff-rules/${lineId}`, lineData);
    return response.data;
  } catch (error) {
    console.error("Error updating tariff-rules:", error);
    throw error;
  }
};
